import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/snapshots",
      name: "snapshots",
      component: () => import("./views/Snapshots.vue")
    },
    {
      path: "/themes/:travel",
      name: "themes",
      component: () => import("./views/Themes.vue")
    },
    {
      path: "/regions/:name",
      name: "regions",
      component: () => import("./views/Regions.vue")
    },
    {
      path: "/first-time-traveler",
      name: "first-time-traveler",
      component: () => import("./views/FirstTimeTravel/FirstTimeTravel.vue")
    },
    {
      path: "/about-mongolia",
      name: "about-mongolia",
      component: () => import("./views/FirstTimeTravel/AboutMongolia.vue")
    },
    {
      path: "/description-mongolia-01",
      name: "description-mongolia-01",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia01.vue")
    },
    {
      path: "/description-mongolia-02",
      name: "description-mongolia-02",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia02.vue")
    },
    {
      path: "/description-mongolia-03",
      name: "description-mongolia-03",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia03.vue")
    },
    {
      path: "/description-mongolia-04",
      name: "description-mongolia-04",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia04.vue")
    },
    {
      path: "/description-mongolia-05",
      name: "description-mongolia-05",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia05.vue")
    },
    {
      path: "/description-mongolia-06",
      name: "description-mongolia-06",
      component: () =>
        import("./views/FirstTimeTravel/DescriptionMongolia06.vue")
    },
    {
      path: "/map",
      name: "map",
      component: () => import("./views/Map.vue")
    },
    {
      path: "/plan",
      name: "plan",
      component: () => import("./views/PlanYourTrip/Layout.vue"),
      children: [
        {
          path: "getting-to-mongolia",
          name: "getting-to-mongolia",
          component: () => import("./views/PlanYourTrip/Getting.vue")
        },
        {
          path: "travel-around",
          name: "travel-around",
          component: () => import("./views/PlanYourTrip/TravelAround.vue")
        },
        {
          path: "customs-culture",
          name: "customs-culture",
          component: () => import("./views/PlanYourTrip/CustomsCulture.vue")
        },
        {
          path: "practical-information",
          name: "practical-information",
          component: () => import("./views/PlanYourTrip/Practical.vue")
        }
      ]
    },
    {
      path: "/contact",
      name: "Contact",
      component: () => import("./views/Contact.vue")
    },
    {
      path: "/404",
      name: "Page404",
      component: () => import("./views/Page404.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("./views/Privacy.vue")
    },
    {
      path: "/terms",
      name: "terms of use",
      component: () => import("./views/Terms.vue")
    },
    {
      path: "/Cookies",
      name: "Cookies",
      component: () => import("./views/Cookies.vue")
    },
    {
      path: "/story/:name",
      name: "StoryDetail",
      component: () => import("./views/StoryDetail.vue")
    },
    {
      path: "/events",
      name: "Events",
      component: () => import("./views/Events.vue")
    },
    {
      path: "/event/:name",
      name: "EventDetail",
      component: () => import("./views/EventDetail.vue")
    },
    {
      path: "/offers/",
      name: "Offers",
      component: () => import("./views/Offers.vue")
    },
    {
      path: "/offer/:name",
      name: "OfferDetail",
      component: () => import("./views/OfferDetail.vue")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("./views/ResetPassword.vue")
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

/**
 * Clear popups on route changed.
 * @param {String} to the target Route Object being navigated to.
 * @param {String} from the current route being navigated away from.
 * @param {function} next this function must be called to resolve the hook
 */
const clearPopups = () => {
  const popups = document.querySelectorAll(".moment-popup");
  const contentPopups = document.querySelectorAll(".content-popup");

  if (popups && popups.length > 0) {
    for (let i in popups) {
      if (popups[i].parentNode) {
        popups[i].parentNode.removeChild(popups[i]);
      }
    }
  }

  if (contentPopups && contentPopups.length > 0) {
    for (let i in contentPopups) {
      if (contentPopups[i].parentNode) {
        contentPopups[i].parentNode.removeChild(contentPopups[i]);
      }
    }
  }
};

router.beforeEach((to, from, next) => {
  clearPopups();
  next();
});

export default router;
